/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

const Container: React.FC = ({ children }) => {
    return (
        <div className="max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
            {children}
        </div>
    )
}

export default Container